import { enums } from "../../../../../shim/jsbridge";
import { InteractiveParams, RlcsParams } from "../reanalyze-form";

export const INITIAL_RLCS_PARAMS: RlcsParams = {
  platform: enums.platforms.WINDOWS_11,
  locale: enums.locales.EN_US,
  geolocation: enums.geolocations.US,
  internet_simulation: false
};

export const INITIAL_INTERACTIVE_PARAMS: InteractiveParams = {
  platform: enums.platforms.WINDOWS_11,
  locale: enums.locales.EN_US,
  geolocation: enums.geolocations.US
};

export const INITIAL_ANALYSIS_SELECTIONS = {
  tc: false,
  ti_cloud: false,
  rl_auxiliary_analysis: false,
  rl_dynamic_analysis: false,
  rl_dynamic_analysis_interactive: false,
  cape: false,
  cisco_secure_malware_analytics: false,
  cuckoo: false,
  fireeye: false,
  joe: false,
  vmray_tcbase: false,
  local_only: false
};

export const INTEGRATIONS = {
  cape: "CAPE",
  cisco_secure_malware_analytics: "Cisco Secure Malware Analytics",
  cuckoo: "Cuckoo",
  fireeye: "Fireeye",
  joe: "Joe",
  vmray_tcbase: "VMRay"
};

export const QUOTA_EXCEEDED = 21500;

export const QUEUED = 20000;

export const RL_SANDBOX_POLL_INTERVAL = 10000;

export const RL_SANDBOX_MAX_TRIES = -1; // indefinite

export const TOO_MANY_RATE_LIMIT_FAILS = 21600;

export const TOO_MANY_RATE_LIMIT_WARNING = 21700;

export const QUOTA_RATE_LIMIT_CODES = [
  QUOTA_EXCEEDED,
  TOO_MANY_RATE_LIMIT_FAILS,
  TOO_MANY_RATE_LIMIT_WARNING
];
